import { computed } from "vue"
import { cartBus, type ProductOption } from "../cartBus"

export const basketCart = computed(() => {
    const currentCartItems = cartBus.value

    return currentCartItems.map((item) => {
        const sortedOptions = [...item.product_option].sort(
            (a, b) => a.sort_order - b.sort_order
        )

        const groupedOptions = sortedOptions.reduce(
            (acc: Record<string, ProductOption[]>, option) => {
                if (!acc[option.optionName]) {
                    acc[option.optionName] = []
                }
                acc[option.optionName].push(option)

                return acc
            },
            {}
        )


        return {
            ...item,
            groupedOptions
        }
    })
})